import React from "react";
import "./index.scss";

import globe from "../../assets/images/globe-sm.svg";
import Phone from "../../assets/images/phone.svg";
import Email from "../../assets/images/email-sm.svg";
import address from "../../assets/images/address.svg";

const ContactForm = () => {
    return (
        <section className="bg-[#D9F4EF] pt-[90px] pb-20">
            <div className="container mx-auto px-4">

                {/* Header */}
                <div className="mb-12">
                    <span className="inline-block mb-4 px-4 py-1 text-sm rounded-full bg-white text-gray-600">
                        Contact InvexFlow
                    </span>

                    <h2 className="text-[38px] md:text-[52px] leading-[1.15] font-semibold text-[#111827] mb-6">
                        Connect With Us
                    </h2>

                    <p className="text-gray-600 text-[16px] md:text-[18px] leading-[30px] max-w-3xl">
                        Thank you for your interest. Please leave your contact
                        details below, and one of our experts will be in touch
                        shortly. We look forward to connecting with you.
                    </p>
                </div>

                {/* Content */}
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 items-stretch">

                    {/* Left Contact Info */}
                    <div className="bg-white rounded-2xl p-6 md:p-8 shadow-sm border border-[#E5E7EB]">

                        <div className="space-y-6">

                            {/* Phone */}
                            <div className="border border-[#E2E8F0] rounded-xl p-4">
                                <div className="flex items-center mb-3">
                                    <img
                                        src={Phone}
                                        className="w-full max-w-[22px] mr-3"
                                        alt="Phone"
                                    />

                                    <h4 className="font-semibold text-[#111827]">
                                        Phone
                                    </h4>
                                </div>

                                <a
                                    href="tel:+923390039359"
                                    className="text-gray-600 hover:text-[#0FB9B1] transition"
                                >
                                    +92 339 0039359
                                </a>
                            </div>

                            {/* Website */}
                            <div className="border border-[#E2E8F0] rounded-xl p-4">
                                <div className="flex items-center mb-3">
                                    <img
                                        src={globe}
                                        className="w-full max-w-[22px] mr-3"
                                        alt="Website"
                                    />

                                    <h4 className="font-semibold text-[#111827]">
                                        Website
                                    </h4>
                                </div>

                                <a
                                    href="https://www.invexflow.com"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="text-gray-600 hover:text-[#0FB9B1] transition"
                                >
                                    www.invexflow.com
                                </a>
                            </div>

                            {/* Email */}
                            <div className="border border-[#E2E8F0] rounded-xl p-4">
                                <div className="flex items-center mb-3">
                                    <img
                                        src={Email}
                                        className="w-full max-w-[22px] mr-3"
                                        alt="Email"
                                    />

                                    <h4 className="font-semibold text-[#111827]">
                                        Email
                                    </h4>
                                </div>

                                <a
                                    href="mailto:info@invexflow.com"
                                    className="text-gray-600 hover:text-[#0FB9B1] transition"
                                >
                                    info@invexflow.com
                                </a>
                            </div>

                            {/* Address */}
                            <div className="border border-[#E2E8F0] rounded-xl p-4">
                                <div className="flex items-center mb-3">
                                    <img
                                        src={address}
                                        className="w-full max-w-[22px] mr-3"
                                        alt="Address"
                                    />

                                    <h4 className="font-semibold text-[#111827]">
                                        Address
                                    </h4>
                                </div>

                                <p className="text-gray-600 leading-[28px]">
                                    D-124, Federal B Area, Block -5, Karachi,
                                    Pakistan
                                </p>
                            </div>

                        </div>
                    </div>

                    {/* Right Side */}
                    <div className="col-span-2 bg-white rounded-2xl overflow-hidden shadow-sm border border-[#E5E7EB]">

                        <div className="h-full min-h-[400px] lg:min-h-[500px] contact-bg rounded-2xl">
                            <div className="h-full flex flex-col justify-end p-8 bg-gradient-to-t from-black/40 to-transparent">

                                <div className="bg-white/90 backdrop-blur-sm rounded-xl p-5 max-w-md">
                                    <h3 className="text-[#111827] text-xl font-semibold mb-2">
                                        Let's build smarter cash flow solutions
                                    </h3>

                                    <p className="text-gray-600 text-sm leading-[26px]">
                                        Speak with our team to explore invoice
                                        financing, partnerships, or embedded
                                        finance solutions tailored for your
                                        business.
                                    </p>
                                </div>

                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </section>
    );
};

export default ContactForm;